
      import API from "!../../bos/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../bos/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../bos/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../bos/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../bos/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../bos/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../bos/node_modules/css-loader/dist/cjs.js!../../bos/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[4].use[2]!./DocumentViewerStyles.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../bos/node_modules/css-loader/dist/cjs.js!../../bos/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[4].use[2]!./DocumentViewerStyles.scss";
       export default content && content.locals ? content.locals : undefined;
